module.exports = __webpack_public_path__ + "img/main_bg.c8cdaaa2.png";